module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-backoffice-parkinglots-overview"
  }, [_vm._m(0), (_vm.item) ? _c('div', {
    staticClass: "tabs-inner-content"
  }, [_vm._l((_vm.item.layout), function(svg, id) {
    return (_vm.item.layout) ? _c('div', {
      staticClass: "row"
    }, [_c('strong', {
      staticClass: "text-center"
    }, [_vm._v("ID: " + _vm._s(id))]), _c('svg', {
      attrs: {
        "viewBox": svg.viewBox,
        "preserveAspectRatio": "xMidYMid meet",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', _vm._l((svg.paths), function(d, id) {
      return _c('path', {
        class: _vm.getClass(id),
        attrs: {
          "d": d.d,
          "transform": d.t
        },
        on: {
          "mouseover": function($event) {
            return _vm.tooltip(id)
          },
          "click": function($event) {
            return _vm.clicked(id)
          }
        }
      })
    }), 0)]), _c('p', {
      staticClass: "center"
    }, [_vm._v(_vm._s(_vm.tooltipText))])]) : _vm._e()
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.picture_external
    }
  })]), _c('div', {
    staticClass: "column small-7"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Description")]), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  }), _c('h3', [_vm._v("Allowed Zone")]), (_vm.item.allowed_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.allowed_zone.name))]) : _c('p', [_vm._v("--")]), _c('h3', [_vm._v("Undesiderable Zone")]), (_vm.item.undesiderable_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.undesiderable_zone.name))]) : _c('p', [_vm._v("--")]), _c('h3', [_vm._v("Forbidden Zone")]), (_vm.item.forbidden_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.forbidden_zone.name))]) : _c('p', [_vm._v("--")])])])])], 2) : _c('loading-spinner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('h2', [_vm._v("Parking Lot Overview")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-730940e7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ParkingLotsOverview.vue
// module id = 2591
// module chunks = 1